import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { hideStickyMenus, showParticipantStickyMenu } from '../../../store/formsState';
import { loadParticipantSectionHeadings } from '../../../store/participantService';
import ParticipantStickyMenu from '../../navigation/participant/ParticipantStickyMenu';
import AccordionHeader from '../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../ui/accordion/AccordionIcon';

import AssetRequest from './assetRequests/AssetRequest';
import FinancialRequest from './financialRequests/FinancialRequest';

import app from '../../../app.module.css';

const RequestInformation = () => {
    //  LOCAL STATE
    const dispatch = useDispatch();

    const initialState = {
        financialRequests: false,
        assetRequests: false
    };
    const [isSection, setIsSection] = useState(initialState);
    const [expanded, setExpanded] = useState('');

    const { currentParticipant, participantSectionHeadings } = useSelector(
        (state) => state.entities.participantService
    );

    //  USE EFFECTS
    useEffect(() => {
        const { contractId } = currentParticipant;
        dispatch(loadParticipantSectionHeadings(contractId));
        dispatch(showParticipantStickyMenu());

        return () => {
            dispatch(hideStickyMenus());
        };
    }, [currentParticipant]);

    /**
     * participantSectionHeadings has changed so will have to clear all accordion entries and
     * if the new participantSectionHeadings exists then repopulate said accordions.
     */
    useEffect(() => {
        let sections;
        if (Object.keys(participantSectionHeadings).length !== 0) {
            sections = (({ financialRequests, assetRequests }) => ({
                financialRequests,
                assetRequests
            }))(participantSectionHeadings);
        } else {
            sections = initialState;
        }
        setIsSection(sections);
    }, [participantSectionHeadings]);

    // EVENT HANDLERS
    const onPanelChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    return (
        <div className={app.withSideBar}>
            <div className={app.pageContainer}>
                <h1 className={app.mainHeading}>Financial Requests & Assets</h1>

                <Accordion
                    slotProps={{ transition: { mountOnEnter: true } }}
                    onChange={() => onPanelChange('requests')}>
                    <AccordionSummary
                        expandIcon={<AccordionIcon />}
                        aria-controls="panel30a-content"
                        id="panel30a-header">
                        <AccordionHeader>Requests</AccordionHeader>
                    </AccordionSummary>
                    <div hidden={!isSection.financialRequests} className={app.accordionDivider}>
                        <Accordion
                            slotProps={{ transition: { mountOnEnter: true } }}
                            expanded={expanded === 'financialRequests'}
                            onChange={() => onPanelChange('financialRequests')}>
                            <AccordionSummary
                                expandIcon={<AccordionIcon />}
                                aria-controls="financial-requests-content"
                                id="financial-header">
                                <AccordionHeader>Financial Requests</AccordionHeader>
                            </AccordionSummary>
                            <AccordionDetails>
                                {expanded === 'financialRequests' && <FinancialRequest />}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                    <div hidden={!isSection.assetRequests} className={app.accordionDivider}>
                        <Accordion
                            slotProps={{ transition: { mountOnEnter: true } }}
                            expanded={expanded === 'assetRequests'}
                            onChange={() => onPanelChange('assetRequests')}>
                            <AccordionSummary
                                expandIcon={<AccordionIcon />}
                                aria-controls="asset-requests-content"
                                id="asset-header">
                                <AccordionHeader>Asset Requests</AccordionHeader>
                            </AccordionSummary>
                            <AccordionDetails>
                                {expanded === 'assetRequests' && <AssetRequest />}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </Accordion>
            </div>
            <div className={app.sideBar}>
                <ParticipantStickyMenu />
            </div>
        </div>
    );
};

export default RequestInformation;
